// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { TbBrandOauth as RawTbBrandOauth } from "react-icons/tb";
export const TbBrandOauth = /* @__PURE__ */ createIcon(RawTbBrandOauth, "TbBrandOauth", 2);
